import React from 'react';
import { bonuses, CHECKOUT_URL } from '../data/hvac';
export function BonusSection() {
  return <section className="border-y-4 border-diag/40 bg-white px-4 py-5 sm:py-7" data-id="element-20" data-mp="1ogdke9dxry3y">
      <div className="mx-auto max-w-4xl" data-id="element-21" data-mp="22fn077y8cq7e">
        <h2 className="text-center text-xl leading-tight text-navy sm:text-3xl" data-id="element-22" data-mp="22ebv94t1tcep">
          🎁 4 Professional Bonuses Included
        </h2>

        <div className="mt-3 grid gap-2 sm:grid-cols-2" data-id="element-23" data-mp="1yc74cdtzitvr">
          {bonuses.map(bonus => <a key={bonus.num} href={CHECKOUT_URL} className="flex flex-col rounded-lg border border-diag/40 bg-off p-3 shadow-sm transition-colors duration-150 hover:border-diag" data-id="element-24" data-mp="1am2zy48z2q3p">
              <p className="text-[11px] font-extrabold uppercase tracking-wide text-diag" data-id="element-25" data-mp="1epixr3ws2whz">
                🎁 Bonus {bonus.num}
              </p>
              <h3 className="mt-0.5 text-base leading-tight text-navy sm:text-lg" data-id="element-26" data-mp="qyn92fnmchey">
                {bonus.title}
              </h3>
              {bonus.body.map(paragraph => <p key={paragraph} className="mt-1 text-sm font-medium leading-snug text-charcoal/80" data-id="element-27" data-mp="29rbeaot76tux">
                  {paragraph}
                </p>)}
              <p className="mt-auto pt-1.5 text-sm font-extrabold uppercase text-service" data-id="element-28" data-mp="2jjzdfq7nh9wt">
                {bonus.kicker}
              </p>
            </a>)}
        </div>
      </div>
    </section>;
}